<template>
	<div class="msg-center-container">
		<div class="msgCenterListBox">
			<!-- 消息分类导航 -->
			<div class="msg-center-nav">
				<div class="msg-categories">
					<div v-for="category in categories" :key="category.key" class="category-item"
						:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
						{{ category.name }}
					</div>
				</div>
				<div class="read-all-btn" @click="markAllAsRead">
					全部已读
				</div>
			</div>

			<!-- 消息状态筛选 -->
			<div class="msg-status-filter">
				<div v-for="status in statuses" :key="status.key" class="status-item"
					:class="{ 'active': activeStatus === status.key }" @click="switchStatus(status.key)">
					{{ status.name }}
					<span v-if="status.count">({{ status.count }})</span>
				</div>
			</div>

			<!-- 消息列表 -->
			<div class="msgCenterList" v-if="msgTypeData">
				<router-link :to="goToPostion(item)" class="msgType" v-for="(item,index) in msgTypeData" :key="index">
					<div class="msgTypeIconBox" @click="changeReadStatus(item)">
						<img class="msgTypeIcon" src="../../assets/platformMsg.png" v-if="item.type == 3" />
						<img class="msgTypeIcon" src="../../assets/activityMsg.png" v-if="item.type == 2" />
						<img class="msgTypeIcon" src="../../assets/inMsg.png" v-if="item.type == 1" />
						<div class="redPoint" v-if="item.status == 2"></div>
					</div>
					<div class="msgTypeTitleBox" @click="changeReadStatus(item)">
						<div class="msgTypeTitle">{{item.content}}>>></div>
						<div class="msgTypeContent ellipsis-1">{{item.title}}｜{{item.create_time}} <span
								class="lookDetails">查看详情<img src="../../assets/Home/msgArrow.png" alt="" /></span>
						</div>
					</div>
				</router-link>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
			<!-- 分页组件 -->
			<PagePagination style="padding: .4rem 0 .2rem;" :currentPage="currentPage" :total="total"
				@current-change="onPageChange" />
		</div>
	</div>
</template>

<script>
	import PagePagination from '../../components/PagePagination.vue'
	export default {
		name: 'MsgCenter',
		components: {
			PagePagination
		},
		data() {
			return {
				loading: false,
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				msgTypeData: [],
				// 分类导航
				categories: [{
						key: 'all',
						name: '全部消息'
					},
					{
						key: '1',
						name: '站内消息'
					},
					// {
					// 	key: '2',
					// 	name: '活动通知'
					// },
					{
						key: '3',
						name: '平台公告'
					}
				],
				// 状态筛选
				statuses: [{
						key: 'all',
						name: '全部',
						count: 0
					},
					{
						key: '1',
						name: '未读',
						count: 0
					}
				],
				// 当前选中的分类和状态
				activeCategory: 'all',
				activeStatus: 'all'
			}
		},
		mounted() {
			if (this.$route.query.type) {
				this.activeCategory = this.$route.query.type
			}
			this.messageList()
		},
		methods: {
			changeReadStatus(item) {
				this.$api.post('/UserD/one_clear_message', {
					id: item.id,
				}).then(res => {
					console.log(res);
				}).catch(err => {
					console.log(err);
				})
			},
			goToPostion(item) {
				if (item.type == 1) {
					if (item.title == '站内通知>提现审核消息') {
						return `/income`
					}
					if (item.title == '站内通知>定制订单消息') {
						return `/painter-make-order-details?type=2&orderId=${item.mb_id}`
					}
					if (item.title == '站内通知>花市订单消息') {
						return `/painter-order-details?type=1&orderId=${item.mb_id}`
					}
					if (item.title == '站内通知>动态消息') {
						return `/painter-msg-super-details?quId=${item.fq_id}&dtId=${item.dt_id}&id=${item.mb_id}`
					}
					if (item.title == '站内通知>群聊通知') {
						return `/painter-chat?userId=${item.mb_id}&type=2`
					}
					if (item.title == '站内通知>私聊通知') {
						return `/painter-chat?userId=${item.mb_id}`
					}
					if (item.title == '站内通知>周边订单消息') {
						return ''
					}
				} else {
					if (item.type == 3) {
						return `/painter-msg-details?id=${item.mb_id}`
					}
				}
			},
			messageList() {
				this.loading = true
				this.$api.post('/UserD/message_list', {
					p: this.currentPage,
					sf_type: 2,
					pagesize: 10,
					status: this.activeStatus == 'all' ? '' : this.activeStatus,
					type: this.activeCategory == 'all' ? '' : this.activeCategory
				}).then(res => {
					this.loading = false
					if (res.code == 1) {
						//status1已读2未读
						this.total = res.data.count
						this.msgTypeData = res.data.list
						this.statuses[0].count = res.data.count
						this.statuses[1].count = res.data.wd_count
						console.log(res)
					}
				}).catch(err => {
					this.loading = false
					console.log(err);
				})
			},
			// 页码变化处理
			onPageChange(newPage) {
				this.currentPage = newPage
				this.messageList()
			},

			// 切换分类
			switchCategory(category) {
				if (this.loading) return
				this.activeCategory = category;
				this.activeStatus = '';
				this.currentPage = 1; // 切换分类时重置到第一页
				this.messageList()
			},

			// 切换状态
			switchStatus(status) {
				this.activeStatus = status;
				this.currentPage = 1; // 切换状态时重置到第一页
				this.messageList()
			},

			// 标记全部为已读
			markAllAsRead() {
				this.$api.post('/UserD/clear_message', {}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.messageList()
					} else {
						this.$message.error(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.msg-center-container {
		margin: .24rem .24rem;
		display: flex;
		background: #FFFFFF;
		border-radius: .08rem;
		height: calc(100vh - 3.66rem);
	}

	.msgCenterListBox {
		width: 100%;
		height: calc(100vh - 3.66rem);
		border-radius: .08rem;
		background: #FFFFFF;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
		padding: 0 .24rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.read-all-btn {
		font-weight: 400;
		font-size: .14rem;
		color: #E29358;
		cursor: pointer;
		transition: color 0.3s ease;
	}

	.read-all-btn:hover {
		color: #D17F3A;
	}

	/* 消息状态筛选样式 */
	.msg-status-filter {
		display: flex;
		padding: .16rem 0 .08rem;
	}

	.status-item {
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;
		padding: .08rem .16rem .06rem;
		background: rgba(226, 147, 88, .3);
		margin-right: .12rem;
		border-radius: .04rem;
		transition: all 0.3s ease;
	}

	.status-item.active {
		background-color: #E29358;
		font-weight: 500;
		color: #252525;
	}

	/* 消息列表样式 */
	.msgCenterList {
		height: calc(100vh - 5.88rem);
		padding: 0 .32rem;
		overflow-y: auto;
	}

	.msgType {
		display: flex;
		align-items: center;
		height: 1rem;
		border-bottom: 1px solid #F0F0F0;
		transition: background-color 0.3s ease;
	}

	a:hover {
		text-decoration: none !important;
	}

	.msgType:hover {
		background-color: #F9F9F9;
	}

	.msgTypeIconBox {
		position: relative;
		margin-right: .16rem;
	}

	.msgTypeIcon {
		width: .48rem;
		height: .48rem;
	}

	.redPoint {
		position: absolute;
		top: -0.04rem;
		right: -0.04rem;
		width: .16rem;
		height: .16rem;
		background-color: #FF0000;
		border-radius: 50%;
		border: 2px solid #FFFFFF;
	}

	.msgTypeTitleBox {
		flex: 1;
	}

	.msgTypeTitle {
		font-size: .16rem;
		font-weight: 500;
		color: #333333;
		margin-bottom: .08rem;
	}

	.msgTypeContent {
		display: flex;
		align-items: center;
		font-size: .14rem;
		color: #606266;

		.lookDetails {
			margin-left: .16rem;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #A88653;

			img {
				margin-left: .04rem;
				width: .05rem;
				height: .08rem;
			}
		}
	}
</style>